export default {
      id: "arrow_bottom-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#arrow_bottom-usage",
      toString: function () {
        return this.url;
      }
    }